import { render, staticRenderFns } from "./EAcoesAuxiliaresLegado.vue?vue&type=template&id=064041a6"
import script from "./EAcoesAuxiliaresLegado.vue?vue&type=script&lang=js"
export * from "./EAcoesAuxiliaresLegado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports